// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subscriptions_AdminTransactionRefundResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Subscriptions_AdminTransactionRefundResponse — result of
 * POST /subscriptions/admin/transactions/{id}/refunded (S12/M3c · D5).
 *
 * Returned ONLY on a real flip. Every refusal — not Full, bad id, unknown row,
 * a row that is not (or no longer) 'refund_pending' — answers through
 * sendError() instead, because sendResponse() always sets success=true and a
 * refusal wearing a success envelope is the bug §4 of skill
 * billing-staff-console has now watched ship three times.
 *
 * status echoes the row's new value rather than assuming it, so the screen
 * renders what the database says.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Subscriptions_AdminTransactionRefundResponseDados {
id: number
status: string
}

export type Subscriptions_AdminTransactionRefundResponse = ApiResponse<Subscriptions_AdminTransactionRefundResponseDados>;

registerResponseContract('Subscriptions_AdminTransactionRefundResponse', {
  id:     { type: 'number',  required: true },
  status: { type: 'string',  required: true },
})
